import { Dispatch, Action } from "redux";
import { AxiosError, AxiosResponse } from "axios";
import { notification } from "antd";

import { mapDataRows, showErrorNotification } from "../../../../utils";
import { ApiService } from "../../../../services";
import { GET_INSURANCE_OFFER_REQUESTS } from "./types";

export const getInsuranceOfferRequests =
  () => async (dispatch: Dispatch<Action>) => {
    ApiService.get("/offer-request")
      .then((res: AxiosResponse) => {
        const { status, data } = res;
        if (status !== 200) {
          showErrorNotification("Učitavanje zahtjeva za ponudu nije uspjelo");
          return;
        }

        const offerRequests = mapDataRows(data.rows);

        dispatch({
          type: GET_INSURANCE_OFFER_REQUESTS,
          payload: offerRequests,
        });
      })
      .catch((err: AxiosError) => {
        showErrorNotification(
          "Učitavanje zahtjeva za ponudu nije uspjelo",
          err
        );
      });
  };
